// Skills (SKILL.md) de la org — una skill ES un OrgWorkflow(kind="skill").
// Backend: mcp_django/apps/company/routers.py (/admin/company/workflows…).
// Lectura con company:read; importar exige company:update (admins).

import { useQuery } from '@tanstack/react-query';

import { djangoApiCall } from '@/lib/api';

export const DOCS_KEY = ['agents-os', 'documents'] as const;
export const SKILLS_KEY = ['agents-os', 'skills'] as const;

export interface OrgSkill {
  slug: string;
  title: string;
  description: string;
  when_to_use: string;
  tools_used: string[];
  tags: string[];
  kind: string;
  status: 'active' | 'draft' | 'disabled' | string;
  version: number;
}

export async function listSkills(): Promise<OrgSkill[]> {
  const rows = await djangoApiCall<OrgSkill[]>('/admin/company/workflows?kind=skill');
  return Array.isArray(rows) ? rows : [];
}

export async function importSkill(skillMd: string): Promise<{ skill: OrgSkill; nueva_version: boolean }> {
  return djangoApiCall('/admin/company/workflows/skills/import', {
    method: 'POST',
    body: JSON.stringify({ skill_md: skillMd, files: {} }),
  });
}

export function useOrgSkills() {
  return useQuery<OrgSkill[]>({ queryKey: SKILLS_KEY, queryFn: listSkills });
}
